import $ from 'jquery';
import APPCONFIG from '../constants/Config';
import { formatApiErrorMessage } from './apiErrorMessage';

function unwrapResponse(data) {
	return data && typeof data.response !== 'undefined' ? data.response : data;
}

function getCheckoutSearchErrorMessage(error) {
	if (error && error.status === 404) {
		return 'Checkout search is not available on this API yet. Deploy the latest API or run the checkout_quick_picks migration.';
	}
	return formatApiErrorMessage(error, 'Could not load checkout items.');
}

export function fetchCheckoutAddableSearch(search = '', limit = 20) {
	const params = new URLSearchParams();
	if (search) {
		params.set('search', search);
	}
	if (limit) {
		params.set('limit', String(limit));
	}

	const query = params.toString();
	const url = `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/checkouts/addable_search${query ? `?${query}` : ''}`;

	return $.ajax({
		type: 'GET',
		url,
		dataType: 'json',
	}).then((data) => {
		const payload = unwrapResponse(data);
		return payload && Array.isArray(payload.groups) ? payload.groups : [];
	});
}

export { getCheckoutSearchErrorMessage };
